import React from "react"
import GooglePlacesAutocomplete from "react-google-places-autocomplete"

import { withHeroForm } from "./withHeroForm"
import { Icon } from "../../../Icon/Icon"
import { StyledColumn } from "../../../Styled/Column"
import { StyledRow } from "../../../Styled/Row"
import {
  StyledInputWrapper,
  StyledSelectWrapper,
  StyledSelectOption,
  SuggestionList,
  SuggestionWrapper,
  SuggestionListItem,
} from "../../../Styled/Form"
import { Form, FormStep, FormItem, FormTitle, Button, Input, Select, WideButton, Steps, Step } from "./HeroFormStyles"

export const HeroForm = withHeroForm(
  ({
    autocompleteConfig,
    handleAutocomplete,
    handleBlur,
    handleChange,
    handleClick,
    handleStep,
    handleSubmit,
    input,
    loading,
    locales,
    packages,
    searchInput,
    step,
    updateSuburb,
  }): JSX.Element => (
    <Form onSubmit={handleSubmit} onClick={handleClick}>
      <FormItem>
        <StyledRow gutter={`sm`} items={`center`}>
          <StyledColumn gutter={`sm`} width={`grow`}>
            <FormStep colour={`navy`} withSpacing={`sm`}>
              <strong>
                {`${locales?.additionalHeroFormStep?.split(`{current}`)?.[0]}
                  ${step + 1}`}
              </strong>
              {locales?.additionalHeroFormStep?.split(`{current}`)?.[1]?.replace(`{total}`, 2)}
            </FormStep>
          </StyledColumn>
          <StyledColumn gutter={`sm`} justify={`md:end`} width={`no-shrink`}>
            <Button
              disabled={loading}
              hidden={!step}
              colour={`light`}
              size={`round-sm`}
              onClick={() => handleStep(step - 1)}
              title={locales?.additionalHeroFormBack}
              type={`button`}
              withIcon
            >
              <Icon name={`chevronLeft`} />
            </Button>
          </StyledColumn>
        </StyledRow>
        <FormTitle colour={`navy`}>{!step ? locales?.additionalHeroFormSuburbProviders : locales?.additionalHeroFormPackage}</FormTitle>
        <Steps>
          <Step active={step === 0}>
            <StyledInputWrapper withSpacing={`none`} full>
              <GooglePlacesAutocomplete
                {...autocompleteConfig}
                loader={<></>}
                onSelect={handleAutocomplete}
                renderInput={props => (
                  <Input
                    {...props}
                    disabled={loading}
                    ref={step === 0 ? input : null}
                    name={`suburb`}
                    placeholder={locales?.additionalHeroFormSuburbPlaceholder}
                    onChange={handleChange}
                    onKeyDown={props.onChange}
                    value={searchInput.suburb}
                  />
                )}
                renderSuggestions={(active, suggestions, onSelectSuggestion) => (
                  <SuggestionWrapper>
                    <SuggestionList>
                      {suggestions.map(sug => (
                        <SuggestionListItem key={sug.place_id} onClick={event => updateSuburb(event, sug, onSelectSuggestion)}>
                          {sug.description}
                        </SuggestionListItem>
                      ))}
                    </SuggestionList>
                  </SuggestionWrapper>
                )}
              />
            </StyledInputWrapper>
            <WideButton type={`submit`} title={locales?.additionalHeroFormNext} disabled={loading} size={`medium`}>
              {locales?.additionalHeroFormNext}
            </WideButton>
          </Step>
          <Step active={step === 1}>
            <StyledSelectWrapper full>
              <Select
                disabled={loading}
                name={`packageLevel`}
                onBlur={handleBlur}
                onChange={handleChange}
                ref={step === 1 ? input : null}
                value={searchInput.packageLevel}
              >
                <StyledSelectOption value={``} disabled>
                  {locales?.additionalHeroFormPackagePlaceholder}
                </StyledSelectOption>
                {packages?.map(({ id, number, title }) => (
                  <StyledSelectOption key={id} value={number}>
                    {title}
                  </StyledSelectOption>
                ))}
              </Select>
              <Icon name={`chevronDown`} />
            </StyledSelectWrapper>
            <WideButton type={`submit`} title={locales?.additionalHeroFormNext} disabled={loading} size={`medium`}>
              {locales?.additionalHeroFormSubmitProviders}
            </WideButton>
          </Step>
        </Steps>
      </FormItem>
    </Form>
  )
)
